module.exports = __webpack_public_path__ + "static/media/certificate-mern-stack.6a7dfb31.pdf";